module.exports = __webpack_public_path__ + "static/media/Gymnasium.86a98781.glb";